







import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store/store";
import moment from "moment";
import axios from "axios";
import SignaturePad from "signature_pad";
import trimCanvas from "./trimCanvas";

@Component({
  components: {},
})
export default class SignatureEntry extends Vue {
  private signaturePad: SignaturePad;

  public mounted() {
    this.initSignaturePad();
  }

  public getData(): string {
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      // store data points before trimming so we can keep size.
      const data = this.signaturePad.toData();

      // trim canvas so dataurl isn't huge and can be stored nicely
      trimCanvas(this.$refs.signaturePad as HTMLCanvasElement);
      const sig = this.signaturePad.toDataURL("base64");

      // add untrimmed image back so it looks the same as before
      this.initSignaturePad();
      this.signaturePad.fromData(data);
      return sig;
    } else {
      return "";
    }
  }

  public loadData(dataUrl: string) {
    this.initSignaturePad();
    const img = new Image();
    img.src = dataUrl;

    img.onload = () => {
      this.canvas
        .getContext("2d")!
        .drawImage(
          img,
          this.canvas.width * 0.1,
          this.canvas.height * 0.1,
          this.canvas.width * 0.8,
          this.canvas.height * 0.8
        );
    };
  }

  public isEmpty() {
    return this.signaturePad.isEmpty();
  }

  public clearSignature() {
    this.signaturePad.clear();
  }

  private initSignaturePad() {
    this.canvas.width = Number.parseInt((this.$el as HTMLElement).style.width || "600", 10);
    this.canvas.height = Number.parseInt((this.$el as HTMLElement).style.height || "200", 10);
    this.signaturePad = new SignaturePad(this.canvas, {
      backgroundColor: "rgb(255, 255, 255)",
      dotSize: 1,
    });
  }

  get canvas() {
    return this.$refs.signaturePad as HTMLCanvasElement;
  }
}
